import { render, staticRenderFns } from "./leader-app.vue?vue&type=template&id=a7319800&scoped=true"
import script from "./leader-app.vue?vue&type=script&lang=js"
export * from "./leader-app.vue?vue&type=script&lang=js"
import style0 from "./leader-app.vue?vue&type=style&index=0&id=a7319800&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7319800",
  null
  
)

export default component.exports